import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getDashboardAnalytics, getBusinessAnalyticsChart } from "../../../api/analytics";
import { getCustomersList } from "../../../api/customer";
import { getOrderDetails } from "../../../api/order";

export const fetchAnalytics = createAsyncThunk("fetchAnalytics", async () => {
  const res = await getDashboardAnalytics();
  return res;
});

export const fetchAnalyticsChart = createAsyncThunk("fetchAnalyticsChart", async (year) => {
  const res = await getBusinessAnalyticsChart(year);
  return res;
});

export const fetchLatestOrders = createAsyncThunk("fetchLatestOrders", async (payload) => {
  const res = await getOrderDetails(payload);
  return res;
});

export const fetchLatestUsers = createAsyncThunk("fetchLatestUsers", async (payload) => {
  const res = await getCustomersList(payload?.pageNumber, payload?.itemPerPage);
  return res;
});

const initialState = {};

const dashboardSlice = createSlice({
  name: "dashboard",
  initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAnalytics.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchAnalytics.fulfilled, (state, action) => {
        state.isLoading = false;
        state.res = action.payload;
      })
      .addCase(fetchAnalytics.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      })
      .addCase(fetchAnalyticsChart.pending, (state) => {
        state.isChartLoading = true;
      })
      .addCase(fetchAnalyticsChart.fulfilled, (state, action) => {
        state.isChartLoading = false;
        state.chart = action.payload;
      })
      .addCase(fetchAnalyticsChart.rejected, (state, action) => {
        state.isChartLoading = false;
        state.chartError = action.error.message;
      })
      .addCase(fetchLatestOrders.pending, (state) => {
        state.isOrderLoading = true;
      })
      .addCase(fetchLatestOrders.fulfilled, (state, action) => {
        state.isOrderLoading = false;
        state.orders = action?.payload?.items;
      })
      .addCase(fetchLatestOrders.rejected, (state, action) => {
        state.isOrderLoading = false;
        state.orderError = action.error.message;
      })
      .addCase(fetchLatestUsers.pending, (state) => {
        state.isUsersLoading = true;
      })
      .addCase(fetchLatestUsers.fulfilled, (state, action) => {
        state.isUsersLoading = false;
        state.users = action?.payload?.items;
      })
      .addCase(fetchLatestUsers.rejected, (state, action) => {
        state.isUsersLoading = false;
        state.userError = action.error.message;
      });
  },
});
export const { reset } = dashboardSlice.actions;
export { dashboardSlice };
